//Symbol Currency Change.
export const DisplaySymbol = (currency: string) => {
  if (currency === 'USD' || currency === 'CAD') {
    return '$';
  } else if (currency === 'EUR') {
    return '€';
  } else if (currency === 'GBP') {
    return '£';
  }
};
